import React from 'react';
import { projects, Project } from './data';
import { motion } from 'framer-motion';
import '../styles/projects.css';

interface ProjectCardProps {
  img: string;
  link: string;
  title: string;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ img, link, title }) => {
  return (
    <motion.div className="project-card" whileHover={{ scale: 1.2 }}>
      <h2 className="project-title">{title}</h2>
      <a className="project-card" href={link} rel="noreferrer" target="_blank">
        <img src={img} alt={title} />
      </a>
    </motion.div>
  );
};

const Projects: React.FC = () => {
  return (
    <div id="projects" className="projects reveal">
      <h1>Projects</h1>
      <div className="project-container">
        {projects.map((proj: Project) => (
          <ProjectCard key={proj.title} img={proj.img} link={proj.link} title={proj.title} />
        ))}
      </div>
    </div>
  );
};

export default Projects;

